import "../../styles/style"
import "../../fixed-view/style"
import "../index.scss"
